import { useTranslation } from 'react-i18next';

import { ComingSoon } from '../components/ComingSoon';
import { PortfolioPageLayout } from './components/PortfolioPageLayout';

export const PortfolioForecastsPage = () => {
  const { t } = useTranslation();

  return (
    <PortfolioPageLayout title={t('navbar.forecasts')}>
      <ComingSoon />
    </PortfolioPageLayout>
  );
};
